import { useState } from "react";
import InputBox from "./SubLogin/InputBox";
import InputPass from "./SubLogin/InputPass";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../Api/Network";
import ErrorNet from "../Dashboard/UserManagment/SubUserManagment/ErrorNet";

function Login() {
    const [userName, setUserName] = useState("");
    const [pass, setPass] = useState("");
    const [error, setError] = useState("");
    const [openError, setOpenError] = useState(false)

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const data = await loginUser(userName, pass);
            if (data.status === 200) {
                localStorage.setItem("token", data.data);
                console.log('localstorage', localStorage.getItem('token'))
                navigate("/dashboard");
            }
            else {
                setError(data.message)
                setOpenError(true)
            }
        } catch (err) {
            setError(err.message);
            setOpenError(true)
        }
    };

    const handleGoBranding = () => {
        navigate("/branding");
    };

    return (
        <>
            <div className="bg-garyLight h-screen flex justify-center">
                <div className="bg-white w-7/12 h-4/6 mt-20 rounded-2xl shadow flex flex-row-reverse">
                    <div className="bg-purpleLight w-1/2 rounded-r-2xl flex flex-col items-center justify-center">
                        <p className="t-purpleDark text-2xl font-black mb-4">پیام رسان بوستان</p>
                        <p className="text-slate-400 text-xs mb-8">به پیام رسان بوستان خوش آمدید</p>
                        <img src="/image/BoostanLogo.png" className=" w-3/4 mb-10" />
                    </div>
                    <form onSubmit={handleLogin} className="w-1/2 flex flex-col items-center justify-center">
                        <img src="/image/Logo.png" className="w-12" />
                        <p className="t-purpleDark font-extrabold text-lg my-4">ورود به بوستان</p>
                        <p className="w-2/4 text-slate-400 text-xs leading-7 mb-10 text-center">
                            .لطفا نام کاربری و کلمه عبور خود را وارد نمایید
                        </p>
                        <InputBox onChange={setUserName} />
                        <InputPass onChange={setPass} />
                        <button type="submit" className="bg-purpleDark text-white w-4/6 py-3 rounded mt-10 text-center">
                            ورود
                        </button>
                        <button type="button" onClick={handleGoBranding} className="bg-purpleDark text-white w-4/6 py-3 rounded mt-2 text-center">
                            ورود به صفحه برندینگ
                        </button>
                        <p className="text-xs text-slate-400 mt-2">نسخه ۴.۲</p>
                    </form>
                </div>
            </div>
            {openError && <ErrorNet close={setOpenError} msg={error} />}
        </>
    );
}
export default Login;
